var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 28.125L28.125 46.875M28.125 28.125L46.875 46.875M68.75 37.5C68.75 54.7589 54.7589 68.75 37.5 68.75C20.2411 68.75 6.25 54.7589 6.25 37.5C6.25 20.2411 20.2411 6.25 37.5 6.25C54.7589 6.25 68.75 20.2411 68.75 37.5Z",
    stroke: "#6E56CF",
    strokeWidth: 4.98438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.51e4cbd659d78277f9a07e7ae140fe40.svg";
export { ForwardRef as ReactComponent };